import React, { Component } from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import * as certificateCrud from '../../../../crud/certificate.crud';
import { notificationAggregateListTagsFilter, notificationUniqueTagsFilter } from "../../../../store/helpers/FilterHelper";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, replyFields, intl) => {
    const formFields = [
        {
            caption: intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.SUBJECT' }),
            dataField: 'subject',
            required: true,
            dataType: 'string',
            min: 1,
            max: 250
        }
    ];

    if (fields.Type.visible) {
        formFields.push({
            caption: fields.Type.label,
            dataField: 'type',
            required: fields.Type.required,
            dataType: 'list',
            options: {
                dataSource: fields.Type.clauses,
                valueExpr: 'display',
                displayExpr: 'display'
            }
        })
    }
    if (fields.TaskOrder.visible) {
        formFields.push({
            caption: fields.TaskOrder.label + ' ID',
            dataField: 'taskorderid',
            required: fields.TaskOrder.required,
            dataType: 'integer',
        })
    }
    if (fields.ProjectOrder.visible) {
        formFields.push({
            caption: fields.ProjectOrder.label + ' ID',
            dataField: 'projectorderid',
            required: fields.ProjectOrder.required,
            dataType: 'integer',
        })
    }
    if (fields.ResetCertifiedDate.visible) {
        formFields.push({
            caption: fields.ResetCertifiedDate.label,
            dataField: 'resetcertifieddate',
            required: fields.ResetCertifiedDate.required,
            dataType: 'bool',
        })
    }
    if (fields.CertifiedDate.visible) {
        formFields.push({
            caption: fields.CertifiedDate.label,
            dataField: 'certifieddatedisplay',
            required: fields.CertifiedDate.required,
            dataType: 'date',
        })
    }
    if (fields.Description.visible) {
        formFields.push({
            caption: fields.Description.label,
            dataField: 'description',
            required: fields.Description.required,
            dataType: 'long-string',
        })
    }
    if (fields.Works.visible) {
        formFields.push({
            caption: fields.Works.label,
            dataField: 'works',
            required: fields.Works.required,
            dataType: 'long-string',
        })
    }
    if (fields.Defects.visible) {
        formFields.push({
            caption: fields.Defects.label,
            dataField: 'defects',
            required: fields.Defects.required,
            dataType: 'long-string',
        });
    }

    if (replyFields) {
        if (replyFields.Status.visible) {
            formFields.push({
                caption: replyFields.Status.label,
                dataField: 'status',
                required: replyFields.Status.required,
                dataType: 'list',
                options: {
                    dataSource: replyFields.Status.replyOptions,
                    valueExpr: 'field',
                    displayExpr: 'display'
                },
                isReplyField: true
            })
        }
    }

    return formFields;
}

class CertificateListPage extends BaseListPage {
    constructor(props) {
        super(props);

        const { replyFields } = props.workflowItem;
        if (this.props.workflowItem.replyEnabled && replyFields.Status.replyOptions) {
            this.replyOptionsQA = replyFields.Status.replyOptions.reduce((obj, item) => ({ ...obj, [item.field]: item.display }), {});
        }
        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }

        this.batchFormFields = getBatchFormFields(this.props.workflowItem.fields, this.props.workflowItem.replyFields, this.props.intl);

        this.state = {
            certificates: null,
            tags: null
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchCertificates();
    }
    fetchCertificates = () => {
        const { companyid, projectid, contractid } = this.props.contract;
        certificateCrud.getCertificates(companyid, projectid, contractid, this.props.notificationType, this.props.accessibleWfIds)
            .then(response => {
                let listData = notificationAggregateListTagsFilter(JSON.parse(response.data.aggregatelist));
                listData = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
                    listData :
                    listData.filter(ntf => ntf.showtasknotification === 1);

                let tagFilters = notificationUniqueTagsFilter(JSON.parse(response.data.uniquetags));

                this.setState({ certificates: listData, tags: tagFilters });
            })
            .catch(err => {
                this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
            });
    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.certificateid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = 'secondary';
        switch (cellInfo.data.status) {
            case 'Awaiting Acceptance':
                badgeVariant = 'warning';
                break;
            case 'Not Communicated':
                badgeVariant = 'secondary';
                break;
            case 'Not Accepted':
            case 'NOT_ACCEPTED':
            case 'NOT_ACCEPTED_RESUBMIT':
                badgeVariant = 'danger';
                break;
            case 'Communicated':
            case 'Accepted':
            case 'Reply Not Required':
            case 'Accepted with comments':
            case 'ACCEPT':
            case 'ACCEPT_WITH_COMMENTS':
            case 'NO_REPLY_REQUIRED':
                badgeVariant = 'success';
                break;
            default:
                break;
        }
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        if (this.replyOptionsQA && this.replyOptionsQA.hasOwnProperty(rowData.status)) {
            return this.replyOptionsQA[rowData.status];
        }
        else {
            return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.status });
        }
    }
    render() {
        if (!this.state.certificates) {
            return (<PortletSpinner />);
        }

        const { fields } = this.props.workflowItem;

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { caption: fields.Subject.label, dataField: "subject" },
            { caption: fields.Description.label, dataField: "description", isHtml: true },
            { caption: fields.Works.label, dataField: "works", isHtml: true },
            { caption: fields.Defects.label, dataField: "defects", isHtml: true },
            { resource: "GENERAL.FORMS.FIELD.COMMUNICATED_BY", dataField: "communicatedby" },
            { caption: fields.CertifiedDate.label, dataField: "certifieddate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { caption: this.props.globalResources.WF_38_NOTIFICATION_NAME, dataField: "taskorderreference", visible: false },
            { caption: this.props.globalResources.WF_72_NOTIFICATION_NAME, dataField: "projectorderreference", visible: false },
            { resource: "GENERAL.FORMS.REPLING_PARTY", dataField: "replyingparty", lookup: { dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }, visible: false },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_CREATED_BY", dataField: "replycreatebyname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_NOTIFIED_TO", dataField: "lastreplydraftednotifiedtoname", visible: false },

        ];

        if (this.props.workflowItem.assetFieldsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }

        if (this.notificationsTagsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.OtherFilter } }
            );
        };

        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }

        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={certificateCrud.importCertificates}
                        batchDeleteEndpoint={certificateCrud.deleteCertificateDrafts}
                        batchCommunicateEndpoint={certificateCrud.communicateCertificateDrafts}
                        onBatchRecordsUpdated={this.fetchCertificates}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.certificates}
                        keyExpr="certificateid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}



export default withListPageProps(CertificateListPage);
